import { locales, type Locale } from "./routing";

/**
 * 사용자가 명시적으로 고른 언어를 브라우저에 남겨두는 단일 저장소.
 * 로그인 여부와 무관하게 동작해야 하므로 DB(preferred_language)가 아니라
 * localStorage 를 쓴다.
 *
 * NOTE: 키 문자열은 public/locale-redirect.js(pre-hydration 스크립트)와 반드시
 * 동기화되어야 함. 그쪽은 plain script 라 이 모듈을 import 할 수 없어 값이 복제돼 있다.
 */
export const PREFERRED_LOCALE_KEY = "preferred-locale";

/** 저장된 선호 locale. 미저장·손상값·스토리지 차단 시 null. */
export function readPreferredLocale(): Locale | null {
  try {
    const raw = localStorage.getItem(PREFERRED_LOCALE_KEY);
    if (raw && (locales as readonly string[]).includes(raw)) {
      return raw as Locale;
    }
  } catch {
    // 스토리지 차단(시크릿 모드 등) — 저장된 값이 없는 것으로 취급
  }
  return null;
}

/** 선호 locale 저장. 실패(시크릿 모드·용량 초과)는 무시한다. */
export function savePreferredLocale(locale: Locale): void {
  try {
    localStorage.setItem(PREFERRED_LOCALE_KEY, locale);
  } catch {
    // 저장 실패는 치명적이지 않음 — 다음 방문 때 다시 감지되면 그만
  }
}
